import { Color } from 'three';

export function convertHexToRGB(color: string) {
  return new Color(color).toArray();
}

export function denormalizeRGB(component: number) {
  return Math.floor(component * 255);
}

export function colorToHex(color: string) {
  if (
    color.match(
      /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(0(\.\d+)?|1(\.0+)?)\s*\)$/,
    )
  ) {
    return rgbaToHex(color);
  }
  return rgbToHex(color);
}

export function rgbToHex(rgb: string) {
  return `#${rgb
    .match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
    ?.slice(1)
    .map((n) => parseInt(n, 10).toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase()}`;
}

export function rgbaToHex(rgba: string) {
  const rgbaValues = rgba.match(/\d+(\.\d+)?/g)!;

  const r = parseInt(rgbaValues[0], 10);
  const g = parseInt(rgbaValues[1], 10);
  const b = parseInt(rgbaValues[2], 10);
  const a = parseFloat(rgbaValues[3]);

  const red = r.toString(16).padStart(2, '0');
  const green = g.toString(16).padStart(2, '0');
  const blue = b.toString(16).padStart(2, '0');

  const alpha = Math.round(a * 255)
    .toString(16)
    .padStart(2, '0');

  return `#${red}${green}${blue}${alpha}`;
}
